<template lang="pug">
  table.table.table--bars
    thead
      tr.table__row.table__row--head
        th.table__cell {{ 'base.animal_group' | translate }}
        th.table__cell {{ 'base.animal_type' | translate }}
        th.table__cell {{ 'base.animal_count' | translate }}
        th.table__cell
    v-table-body(
      :cols="4"
      :loading="loading"
      :empty="!items.length")
      groups-table-row(
        v-for="group in items"
        :key="group.id"
        :item="group"
        @select="$emit('select', $event)")
</template>

<script>
import api from '@/api'
import GroupsTableRow from './GroupsTableRow'
import paginationMixin from '@/mixins/pagination.mixin'

export default {
  name: 'GroupsTable',

  mixins: [paginationMixin],

  mounted () {
    this.setupPagination(
      api.groups.list,
      { farm: this.$route.params.farm_id },
      `farm_${this.$route.params.farm_id}_groups`
    )
  },

  components: {
    GroupsTableRow
  },

  computed: {
    allowView () {
      return this.hasPermission('group', 'view')
    }
  }
}
</script>

<style lang="scss" scoped>
.table__cell {
  &:nth-child(1) {
    width: 35%;
  }
  &:nth-child(2) {
    width: 40%;
  }
  &:nth-child(3) {
    width: 25%;
  }
}
</style>
